import { Modal, Button } from "antd";
import { updateReportRequestStatusApi } from "api/reportRequest";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import {
  IReportRequest,
  IReportRequestUpdateStatus,
} from "models/reportRequest";
import { useState } from "react";

interface IProp {
  open: boolean;
  reportRequest: IReportRequest;
  handleClose: () => void;
}

export default function ApproveModal({
  open,
  reportRequest,
  handleClose,
}: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadReportRequests } = useDataLoadingContext();
  const handleApprove = async () => {
    setLoading(true);
    const { data, error } = await updateReportRequestStatusApi(
      reportRequest.id,
      {
        status: "approved",
      } as IReportRequestUpdateStatus
    );
    if (data) {
      showSuccess("Report Request Approved successfully");
      loadReportRequests();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to approve {reportRequest.reason}
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleApprove} loading={loading} type="primary">
            Approve
          </Button>
        </div>
      </div>
    </Modal>
  );
}
